/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import { TBookingRequest, TUser } from '../../../../types';

export type TAgentRateProps = {
    bookingRequest: TBookingRequest;
    user: TUser;
    basicRates: {
        freelancer_pay_per_hour: number | string,
        client_pay_per_hour: number | string,
    };
    setBasicRates: any;
    mode: string;
};

export default function AgentRate({
    bookingRequest,
    user,
    basicRates,
    setBasicRates,
    mode,
}:TAgentRateProps) {
    const canEditRates = mode !== 'edit' || bookingRequest.managed;

    useEffect(() => {
        if (mode !== 'create') {
            setBasicRates({
                freelancer_pay_per_hour: bookingRequest.freelancer_pay_per_hour,
                client_pay_per_hour: bookingRequest.client_pay_per_hour,
            });
        }
    }, [bookingRequest.freelancer_pay_per_hour, bookingRequest.client_pay_per_hour]);

    const handleOnChange = (event: any, fieldName: string) => {
        const newState = {
            ...basicRates,
            [fieldName]: event.target.value ? Number(event.target.value) : ''
        };
        setBasicRates(newState);
    };

    return (
        <div className="agent-rates">
            <div className="flex-display flex-display--start shift-form-row-wrap">
                <div className="shift-form-field shift-form-field--half small-margin-bottom">
                    <label htmlFor="freelancer_pay_per_hour">Workers rate</label>
                    <input
                        type="number"
                        step="0.25"
                        id="freelancer_pay_per_hour"
                        value={basicRates.freelancer_pay_per_hour}
                        onChange={event => {
                            handleOnChange(event, 'freelancer_pay_per_hour');
                        }}
                        disabled={!canEditRates}
                    />
                </div>
                {!user.agency.features.includes('self_managed') && (
                    <div className="shift-form-field shift-form-field--half small-margin-bottom">
                        <label htmlFor="client_pay_per_hour">Client rate</label>
                        <input
                            type="number"
                            step="0.25"
                            id="client_pay_per_hour"
                            value={basicRates.client_pay_per_hour}
                            onChange={event => {
                                handleOnChange(event, 'client_pay_per_hour');
                            }}
                            disabled={!canEditRates}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
